<div class="form col-lg-12">
  <button (click)="newComponent()" class="btn btn-danger claroredbg"
          *ngIf="displayNewComponentBtn">{{ 'dataform.new_component.title'|translate }}
  </button>
</div>
<div class="form col-lg-12" *ngIf="lstComponent.length > 0">

  <button *ngIf="displayOptionMntCom != 0" (click)="save()"
          class="btn waves-light btn-danger claroredbg btn-save">{{ 'common.btn.save_changes'|translate }}
  </button>
  <div *ngFor="let component of lstComponent" class="col-lg-12 mb-3">
    <h3>{{ component.description }}</h3>
    <div class="component_group p-3">
      <div class="row" *ngFor="let group of component.listComponentGroupAttribute">
        <div class="col-lg-12">
          <h5>{{ group.description }}</h5>
        </div>

        <!-- editables -->
        <div class="col-lg-3 col-md-4 col-sm-6 col-xs-6" *ngFor="let att of group.listComponentAttribute">
          <div class="form-group has-float-label">
            <!-- Tipo 1 : List -->
            <select class="form-control" *ngIf="att.attribute_type_id == 1" [(ngModel)]="att.idlist" (change)="changeSelected($event)" [disabled]="isDisabled(att)">
              <option [value]="null">{{ 'dataform.implementation.tabs.components.option_empty' | translate }}</option>
              <option *ngFor="let op of att.list" [ngValue]="+op.id">{{ op.descripcion }}</option>
            </select>
            <!-- Tipo 2 : Text  -->
            <input class="form-control" type="text" *ngIf="att.attribute_type_id == 2" [(ngModel)]="att.valortxt" [disabled]="isDisabled(att)"/>
            <!-- Tipo 3 : Number  -->
            <input class="form-control" type="number" placeholder="0.00" step="0.50" *ngIf="att.attribute_type_id == 3"
                   [(ngModel)]="att.valornum" [disabled]="isDisabled(att)"/>
            <!-- Tipo 4 : Date  -->
            <input class="form-control" type="date" *ngIf="att.attribute_type_id == 4" lang="en-US"
                   [(ngModel)]="att.valordateTxt" [disabled]="isDisabled(att)"/>
            <!-- Tipo 12 : time  -->
            <div *ngIf="att.attribute_type_id == 12 && !isDisabled(att)" class="w-100">
              <input class="form-control" [ngxTimepicker]="appendedToInput" [format]="24" [(ngModel)]="att.valortxt"
                     readonly>
              <ngx-material-timepicker #appendedToInput [cancelBtnTmpl]="cancelBtn" [confirmBtnTmpl]="confirmBtn"
                                       [appendToInput]="true"
              ></ngx-material-timepicker>
              <ng-template #cancelBtn>
                <button class="btn btn-danger mr-2" >{{ 'dataform.implementation.time_picker.btn_cancel'|translate }}
                </button>
              </ng-template>
              <ng-template #confirmBtn>
                <button
                  class="btn btn-outline-danger" >{{ 'dataform.implementation.time_picker.btn_accept'|translate }}
                </button>
              </ng-template>
            </div>

            <!-- DESHABILITADO (sin directiva => no abre el popup) -->
            <div *ngIf="att.attribute_type_id == 12 && isDisabled(att)" class="w-100">
              <input class="form-control"
                    [value]="att.valortxt"
                    disabled
                    readonly>
            </div>

            <!-- Tipo 5 : List Query  -->
          <select class="form-control" *ngIf="att.attribute_type_id == 5" [(ngModel)]="att.idlist"
          (change)="changeSelected($event)" [disabled]="isDisabled(att)">
          <option [value]="null">{{ 'dataform.implementation.tabs.components.option_empty' | translate }}</option>
          <option *ngFor="let op of att.list" [ngValue]="+op.id">{{ op.descripcion }}</option>
          </select>

            <!-- Tipo 6 : Check -->
            <input *ngIf="att.attribute_type_id == 6" type="checkbox" [(ngModel)]="att.valorcheckBoolean" [disabled]="isDisabled(att)"
            />
            <!-- Tipo 7 : Text Area -->
            <textarea class="form-control" type="text" *ngIf="att.attribute_type_id == 7" [(ngModel)]="att.valortxtarea" [disabled]="isDisabled(att)"
            ></textarea>
            <!-- Tipo 8 : URL API  -->
            <ng-container *ngIf="att.attribute_type_id == 8">
              <select class="form-control" [(ngModel)]="att.valortxt"  *ngIf="att.label.includes('Campus')"
                      (change)="changeSelections($event, 1)" [disabled]="isDisabled(att)">
                <option [value]="null">{{ 'dataform.implementation.tabs.components.option_empty' | translate }}</option>
                <option *ngFor="let op of listCampus" [ngValue]="op.descripcion">{{ op.descripcion }}</option>
              </select>
              <select class="form-control" [(ngModel)]="att.valortxt" *ngIf="att.label.includes('Building')"
                      (change)="changeSelections($event, 2)" [disabled]="isDisabled(att)">
                <option [value]="null">{{ 'dataform.implementation.tabs.components.option_empty' | translate }}</option>
                <option *ngFor="let op of listBuilding" [ngValue]="op.descripcion">{{ op.descripcion }}</option>
              </select>
              <select class="form-control" [(ngModel)]="att.valortxt" *ngIf="att.label.includes('Floor')"
                      (change)="changeSelections($event, 3)" [disabled]="isDisabled(att)">
                <option [value]="null">{{ 'dataform.implementation.tabs.components.option_empty' | translate }}</option>
                <option *ngFor="let op of listFloor" [ngValue]="op.descripcion">{{ op.descripcion }}</option>
              </select>
              <select class="form-control" [(ngModel)]="att.valortxt" *ngIf="att.label.includes('Room')" [disabled]="isDisabled(att)"
              >
                <option [value]="null">{{ 'dataform.implementation.tabs.components.option_empty' | translate }}</option>
                <option *ngFor="let op of listRoom" [ngValue]="op.descripcion">{{ op.descripcion }}</option>
              </select>
            </ng-container>
            <!-- Tipo 10 : Address  -->
            <div class="input-group mb-3" *ngIf="att.attribute_type_id == 10">
              <div class="input-group-prepend">
                <span class="btn btn-sm btn-danger claroredbg" (click)="showMapSelection(att)"  ><span
                  class="mdi mdi-map-marker"></span><small>{{ att.label }} <span
                  *ngIf="att.mandatory == 1">*</span></small></span>
              </div>
              <input type="text" class="form-control" [(ngModel)]="att.valortxt" [disabled]="isDisabled(att)">
            </div>
            <!-- Tipo 11 : Textref  -->
            <input class="form-control" type="text" *ngIf="att.attribute_type_id == 11" [(ngModel)]="att.valortxt" [disabled]="isDisabled(att)"
            />
            <label *ngIf="att.attribute_type_id != 10">{{ att.label }} <span *ngIf="att.mandatory == 1">*</span></label>
          </div>

          <!--          input file -->
          <div class="input-group" *ngIf="att.attribute_type_id == 13">
            <div class="form-control position-relative p-2"
                 (drop)="onDrop($event,att, att.idcomponentdet, att.loteId)"
                 (dragover)="onDragOver($event, att)"
                 (dragleave)="onDragLeave($event, att)"
                 [class.drag-over]="att.isDragOver">
              <input type="file" class="d-none" accept=".xls, .xlsx"
                     (change)="onFileSelected($event, att.idcomponentdet, att.loteId)" #fileInput [disabled]="isDisabled(att)"/>
              <p class="m-0 label-and-input">
                <button class="btn btn-link p-0 text-black" (click)="triggerFileInput(fileInput)" [disabled]="isDisabled(att)">
                  <i class="fa fa-upload" [ngClass]="{'text-danger': !att.file_name}"></i>
                  <span class="ml-1" [ngClass]="{'text-danger': !att.file_name}">
          {{ att.file_name ? att.file_name : ('dataform.implementation.tabs.components.select_file' | translate) }}
        </span>
                </button>
              </p>
            </div>
            <button class="btn btn-outline-secondary"
                    pTooltip="{{ 'dataform.implementation.tabs.components.download_template' | translate }}"
                    tooltipPosition="top"
                    type="button"
                    (click)="downloadTemplate(att.idcomponentdet, att.loteId)" [disabled]="isDisabled(att)">
              <i class="text-danger fa fa-download"></i>
            </button>
            <button class="btn btn-outline-secondary"
                    pTooltip="{{ 'common.tooltip.show_history' | translate }}"
                    tooltipPosition="top"
                    type="button"
                    (click)="showHistorical(att.idcomponentdet)" [disabled]="isDisabled(att)">
              <i class="text-danger fa fa-folder"></i>
            </button>
          </div>
        </div>

        <!-- no editables -->
        <div class="col-lg-3 col-md-4 col-sm-6 col-xs-6" *ngFor="let att of group.listComponentAttributeNoEdit">
          <div class="form-group has-float-label">
            <!-- Tipo 1 : List  -->
            <select class="form-control" *ngIf="att.attribute_type_id == 1" [(ngModel)]="att.idlist" disabled>
              <option *ngFor="let op of att.list" value="{{att.id}}">{{ op.descripcion }}</option>
            </select>
            <!-- Tipo 2 : Text  -->
            <input class="form-control" type="text" *ngIf="att.attribute_type_id == 2" [(ngModel)]="att.valortxt"
                   disabled/>
            <!-- Tipo 3 : Number  -->
            <input class="form-control" type="number" placeholder="0.00" step="0.50" *ngIf="att.attribute_type_id == 3"
                   [(ngModel)]="att.valornum" disabled/>
            <!-- Tipo 4 : Date  -->
            <input class="form-control" type="date" *ngIf="att.attribute_type_id == 4" lang="en-US"
                   [(ngModel)]="att.valordateTxt" disabled/>
            <!-- Tipo 5 : List Query  -->
            <select class="form-control" *ngIf="att.attribute_type_id == 5" [(ngModel)]="att.idlist" disabled>
              <option *ngFor="let op of att.list" value="{{att.id}}">{{ op.descripcion }}</option>
            </select>
            <!-- Tipo 6 : Check -->
            <input type="checkbox" *ngIf="att.attribute_type_id == 6" [(ngModel)]="att.valorcheckBoolean" disabled/>
            <!-- Tipo 7 : Text Area -->
            <textarea class="form-control" type="text" *ngIf="att.attribute_type_id == 7" [(ngModel)]="att.valortxtarea"
                      disabled></textarea>
            <!-- Tipo 8 : URL API  -->
            <!--select class="form-control" *ngIf="att.attribute_type_id == 8" [(ngModel)]="att.valortxt">
            </select-->
            <ng-container *ngIf="att.attribute_type_id == 8">
              <select class="form-control" [(ngModel)]="att.valortxt" *ngIf="att.label.includes('Campus')"
                      (change)="changeSelections($event, 1)" disabled>
                <option [value]="null">{{ 'dataform.implementation.tabs.components.option_empty' | translate }}</option>
                <option *ngFor="let op of listCampus" [value]="op.descripcion">{{ op.descripcion }}</option>
              </select>
              <select class="form-control" [(ngModel)]="att.valortxt" *ngIf="att.label.includes('Building')"
                      (change)="changeSelections($event, 2)" disabled>
                <option [value]="null">{{ 'dataform.implementation.tabs.components.option_empty' | translate }}</option>
                <option *ngFor="let op of listBuilding" [value]="op.descripcion">{{ op.descripcion }}</option>
              </select>
              <select class="form-control" [(ngModel)]="att.valortxt" *ngIf="att.label.includes('Floor')"
                      (change)="changeSelections($event, 3)" disabled>
                <option [value]="null">{{ 'dataform.implementation.tabs.components.option_empty' | translate }}</option>
                <option *ngFor="let op of listFloor" [value]="op.descripcion">{{ op.descripcion }}</option>
              </select>
              <select class="form-control" [(ngModel)]="att.valortxt" *ngIf="att.label.includes('Room')" disabled>
                <option [value]="null">{{ 'dataform.implementation.tabs.components.option_empty' | translate }}</option>
                <option *ngFor="let op of listRoom" [value]="op.descripcion">{{ op.descripcion }}</option>
              </select>
            </ng-container>
            <!-- Tipo 10 : Address  -->
            <input class="form-control" type="address" *ngIf="att.attribute_type_id == 10" [(ngModel)]="att.valortxt"
                   disabled/>
            <!-- Tipo 11 : Textref  -->
            <input class="form-control" type="text" *ngIf="att.attribute_type_id == 11" [(ngModel)]="att.valortxt"
                   disabled/>
            <label>{{ att.label }}</label>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
